import React from 'react';

import alphaWolf from 'assets/logo/alphaWolf.png';

interface AlphaWolfMarkProps {
  size: number;
  colour: string;
  opacity?: number;
}

const AlphaWolfMark = React.forwardRef<HTMLDivElement, AlphaWolfMarkProps>(
  ({ size, colour, opacity = 1 }, ref) => (
    <div
      ref={ref}
      aria-hidden="true"
      data-testid="alpha-wolf-mark"
      style={{
        width: size,
        height: size,
        backgroundColor: colour,
        opacity,
        WebkitMaskImage: `url(${alphaWolf})`,
        maskImage: `url(${alphaWolf})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        willChange: 'transform',
        transition:
          'opacity 250ms ease-out, width 250ms ease-out, height 250ms ease-out',
      }}
    />
  ),
);

AlphaWolfMark.displayName = 'AlphaWolfMark';

export default AlphaWolfMark;
